module.exports = "./img/desktop_logo.9081737.png";